import { config } from 'dotenv';
import CONTRACTS from './CONTRACTS';

config();

const contractId = {
  BASE: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_BASE,
  UPGRADE: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_UPGRADE,
  TERMS_AND_CONDITIONS: process.env.MICROSERVICE_CONSENTS_TERMS_UUID,
  SUPERAPPLY: process.env.MICROSERVICE_CONSENTS_CONTRACT_UUID_SUPERAPPLY,
};

export default {
  CANDIDATE: {
    CANDIDATES: candidateId => `${process.env.URL_MICROSERVICE_CANDIDATES}/v1/candidates/${candidateId}`,
  },
  CREDIT_CARD: {
    INSERT: `${process.env.URL_MICROSERVICE_CREDIT_CARD_SERVER}/inserir-dados-cartao/salvar-cartao/`,
  },
  JOB_SEARCH: {
    PROFILE_SUMMARIES: (profileId, candidateId) => `${process.env.URL_MICROSERVICE_JOBS_SEARCH}/v1/profiles/${profileId}/summaries/?_candidate.id=${candidateId}`,
    PLAN_CANDIDATE_SUMMARIES: `${process.env.URL_MICROSERVICE_JOBS_SEARCH}/v1/summaries/?_fields=jobs,filters.profile.id&profile.id=`,
  },
  PAYMENT: {
    PLAN: (profileId, candidateId, hashPlans) => {
      const url = `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/plans?_candidate.id=${candidateId}&planCandidate.id=${profileId}`;
      if (hashPlans) return `${url}&_hash=${hashPlans}`;
      return url;
    },
    GROUP_PLANS: (groupId, profileId) => `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/groups/${groupId}/plans?planCandidate_id=${profileId}`,
    COUPON_PLANS: (groupId, promocode) => `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/groups/${groupId}/plans?promocode=${promocode}`,
    DISCOUNT_PLAN: (planId, maxDiscount) => `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/discount-plan-from-id/${planId}/${maxDiscount}`,
    LIMITED_APPLY_PLAN: (profileId, isTrial) => `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/limited-apply?profileId=${profileId}&trial=${isTrial}&apple=false`,
    MONTHLY_PLAN_BY_PRICE: (price, profileId, periodicity) => `${process.env.URL_MICROSERVICE_CVO_PAYMENT_PLANS}/v1/monthly-plan-by-price/${profileId}/${price}?periodicityMonths=${periodicity}`,
  },
  SUBSCRIPTIONS: {
    UPDATE: subscriptionId => `${process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS}/v1/subscriptions/${subscriptionId}`,
    INSERT: `${process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS}/v1/subscriptions/`,
    GET: candidateId => `${process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS}/v1/subscriptions/?candidate.id=${candidateId}`,
    IS_LIMITED_APPLY_USER: candidateId => `${process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS}/v1/subscriptions/is-limited-apply?candidateID=${candidateId}`,
    TRIALS: candidateId => `${process.env.URL_MICROSERVICE_CVO_SUBSCRIPTIONS}/v1/subscriptions/trials?candidateID=${candidateId}`,
  },
  PAYMENT_GATEWAY: {
    LAST_CHARGE: `${process.env.URL_API_PAYMENT_GATEWAY}/v1/last-charge-status/`,
    SOURCES: candidateId => `${process.env.URL_API_PAYMENT_GATEWAY}/v1/customers/${candidateId}/sources`,
  },
  AUDIT: {
    SAVE_LOAD: `${process.env.URL_MICROSERVICE_AUDITS}/v1/audits/`,
    SAVE_CREATED: `${process.env.URL_MICROSERVICE_AUDITS}/v1/candidatesCreate/audits/`,
    SAVE_CANDIDATE_PRICE: `${process.env.URL_MICROSERVICE_AUDITS}/v1/candidatesPrice/audits`,
  },
  BILLING_AUTHENTICATION: {
    ACCESS_TOKEN: `${process.env.URL_BILLING_AUTHENTICATION}/auth/token`,
  },
  BILLING_API: {
    GET_CHARGE_STATUS: (candidateId, chargeId) => `${process.env.URL_BILLING_API}/v1/customers/${candidateId}/charges/status/${chargeId}`,
    GET_CHARGE_STATUS_V2: (candidateId, chargeId) => `${process.env.URL_BILLING_API}/v2/customers/${candidateId}/charges/${chargeId}/status`,
  },
  BANKSLIP: {
    GET: `${process.env.URL_MICROSERVICE_BANKSLIP}`,
  },
  CARD_VALIDATOR: {
    VALIDATE: `${process.env.URL_MICROSERVICE_CARD_VALIDATOR}/validate/bin`,
  },
  USER: {
    USER_API: candidateId => `${process.env.URL_USER_API_MOSSAD}/${candidateId}`,
    AUTHENTICATION_INFO: candidateId => `${process.env.URL_USER_API}/${candidateId}/autenticacao`,
    PHOTO: candidateId => `${process.env.URL_CATHO_PHOTO}/${candidateId}.foto/`,
    SIGNOUT_URL: process.env.USER_AUTH_SIGNOUT_URL,
    AUTH_API_KEY: `${process.env.USER_AUTH_API_KEY}`,
  },
  CONSENTS: {
    API_KEY: `${process.env.MICROSERVICE_CONSENTS_API_KEY}`,
    CONTRACT_URL: (contractType = CONTRACTS.UPGRADE, version = 'latest') => `${process.env.MICROSERVICE_CONSENTS_URL}/terms/${contractId[contractType]}/versions/${version}`,
    TERMS_AND_CONDITIONS_URL: (termType = CONTRACTS.TERMS_AND_CONDITIONS, version = 'latest') => `${process.env.MICROSERVICE_CONSENTS_URL}/terms/${contractId[termType]}/versions/${version}`,
    ACCEPT_URL: `${process.env.MICROSERVICE_CONSENTS_URL}/consents`,
    CONTRACT_UUID: (contractType = CONTRACTS.UPGRADE) => `${contractId[contractType]}`,
    TERM_UUID: (contractType = CONTRACTS.TERMS_AND_CONDITIONS) => `${contractId[contractType]}`,
    VERSION_URL: (contractType = CONTRACTS.TERMS_AND_CONDITIONS, termVersion) => `${process.env.MICROSERVICE_CONSENTS_URL}/consents?termId=${contractId[contractType]}&termVersion=${termVersion}&latest=true`,
  },
  CANDIDATURA: {
    PRIVATE_KEY: `${process.env.MICROSERVICE_CANDIDATURA_PRIVATE_KEY}`,
    APPLICATION_URL: `${process.env.MICROSERVICE_CANDIDATURA_URL}/v2/candidaturas`,
  },
  GEOIP: {
    GET: ip => `${process.env.MICROSERVICE_GEOIP_URL}/json/${ip}`,
  },
  MAILER: {
    API_URL: process.env.MAILER_API_URL,
    API_KEY: process.env.MAILER_API_KEY,
  },
  STANDOUT: {
    TOKEN: process.env.STANDOUT_API_TOKEN,
    HTTP_PROXY: process.env.STANDOUT_HTTP_PROXY,
    USER_RANK_POSITION: `${process.env.URL_STANDOUT_API}/cv_rank_position/user`,
  },
  EXPERIMENT: {
    URL: process.env.URL_MICROSERVICE_EXPERIMENT,
    NAME_ID: process.env.EXPERIMENT_NAME_ID,
    FOR_DEVS: process.env.EXPERIMENT_FOR_DEVS,
    HTTP_PROXY: process.env.STANDOUT_HTTP_PROXY,
  },
  EVENTBUS: {
    PUBLISH_EVENT: `${process.env.EVENTBUS_API_URL}`,
    KEY: process.env.EVENTBUS_API_KEY,
  },
  APPLY: {
    AVAILABLE: `${process.env.URL_MICROSERVICE_APPLY}/charged-apply/available/`,
    KEY: process.env.MICROSERVICE_APPLY_API_KEY,
  },
  CHECKOUT: {
    APPLY: `${process.env.URL_MICROSERVICE_CHECKOUT}/charged-apply/checkout/`,
    CVO_SUBSCRIPTION: `${process.env.URL_MICROSERVICE_CHECKOUT}/cvo-subscription/checkout/plans`,
    CVO_SUBSCRIPTION_TRIAL_PLANS: `${process.env.URL_MICROSERVICE_CHECKOUT}/trial-plan`,
    CANCEL_CHARGE: `${process.env.URL_MICROSERVICE_CHECKOUT}/billing-cancel-charge`,
    VISITS: `${process.env.URL_MICROSERVICE_CHECKOUT}/visits`,
    KEY: process.env.MICROSERVICE_CHECKOUT_API_KEY,
  },
};